import { URL_REPLACEMENT } from '$const';
import { SearchAutoComplete } from '~modules/media-library/model/SearchAutoComplete';
import { get } from '~services/api/methods';

export async function fetchAutoComplete(query = '') {
  const params = new URLSearchParams();
  params.set('q', query);
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/autocomplete/mam-search.php?${params}`;
  const response = await get<SearchAutoComplete>(requestUrl);
  return response;
}

export async function fetchAutoCompleteForFreeTags(query = '') {
  const params = new URLSearchParams();
  params.set('q', query);
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/autocomplete/freetags.php?${params}`;
  const response = await get<SearchAutoComplete>(requestUrl);
  return response;
}
